import { Controller } from 'react-hook-form'

import ErrorIcon from '@mui/icons-material/Error'
import { TextField } from '@mui/material'

import type * as React from 'react'
import type { Control, ControllerProps, FieldValues, Path } from 'react-hook-form'
import type { StandardTextFieldProps } from '@mui/material'

interface ControlledInputProps<TFieldValues extends FieldValues = FieldValues> extends StandardTextFieldProps {
  name: Path<TFieldValues>
  label?: string
  validationRules?: ControllerProps<TFieldValues, Path<TFieldValues>>['rules']
  control: Control<TFieldValues>
  helperText?: string
  className?: string
  endAdornment?: React.ReactNode
}

export const ControlledInput = <TFieldValues extends FieldValues = FieldValues>({
  name,
  label = '',
  validationRules = {},
  control,
  placeholder,
  defaultValue,
  endAdornment,
  ...props
}: ControlledInputProps<TFieldValues>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...props}
          id={name}
          label={label}
          variant="outlined"
          {...field}
          value={field.value ?? defaultValue ?? ''}
          error={!!error}
          helperText={
            error ? (
              <>
                <ErrorIcon fontSize="small" color="inherit" />
                {error.message}
              </>
            ) : null
          }
          placeholder={placeholder}
          InputProps={{
            endAdornment,
          }}
          sx={{
            '& .MuiFormHelperText-root': {
              marginLeft: 0,
            },
          }}
        />
      )}
      rules={validationRules}
    />
  )
}
